<template>
  <v-layout row wrap  v-if="is_list_available">
      <v-flex xs12>
        <ScreenerList :list="ongoingList.data" :is_ongoing="true"></ScreenerList>
      </v-flex>
    <v-flex xs12 v-if="ongoingList.data && ongoingList.data.length && total > 1">
      <div class="text-xs-center mb-4">
        <v-pagination
          v-model="page"
          :length="total"
          :total-visible="7"
        ></v-pagination>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
import {mapState} from 'vuex';
import ScreenerList from '@/components/screener/List';
export default {
  name: 'ScreenerOngoing',
  metaInfo() {
    return {
      title: 'Screeners',
    };
  },
  components: {
    ScreenerList,
  },
  data: () => ({
    is_list_available: false,
    page: 1,
    perPage:12,
  }),

  computed: {
    ...mapState({
      ongoingList: (state) => state.screening.ongoingList,
    }),
    total: function() {
      return this.ongoingList.last_page;
    },
  },
  watch: {
    ongoingList() {
      this.is_list_available = true;
    },
    page: {
      handler: 'getApiData',
      deep: true,
    },
  },
  created() {
    this.getApiData();
  },
  methods: {
    async getApiData() {
      try {
        await this.$store.dispatch('screening/ongoingList',{
          page: this.page,
          perPage: this.perPage,
          search: this.search
        });
      } catch (error) {
        this.$store.dispatch('app/showMessage', {
          message: error.message,
          color: 'error',
        });
      }
    },
  },
};
</script>
